// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"657":"e8ac5e19","914":"4fd394e0"}[chunkId] + ".chunk.css";
};